import { useQuery } from '@apollo/client';
import { PROFILES_QUERY } from '../../queries';

export function useProfilesQuery( options ) {
    return useQuery( PROFILES_QUERY, options );
}
